import type { Router } from "vue-router";
import { createApp, h } from "vue";
import { ElWatermark } from "element-plus";

export const excludePage = ["/login"];
const eleId = "__global_watermark__";

let watermarkApp: ReturnType<typeof createApp> | null = null;
let mountEl: HTMLElement | null = null;
let observer: MutationObserver | null = null;

export function createWatermark() {
  removeWatermark();

  const text = localStorage.getItem("waterMark") || "";
  const mode = localStorage.getItem("responsive-layout");
  const darkMode = JSON.parse(mode || "{}")?.darkMode;
  const color = darkMode ? "rgba(255, 255, 255, .1)" : "rgba(0, 0, 0, .1)";

  mountEl = document.createElement("div");
  mountEl.id = eleId;
  Object.assign(mountEl.style, {
    position: "fixed",
    inset: "0",
    width: "100vw",
    height: "100vh",
    zIndex: "999999",
    pointerEvents: "none"
  });
  document.body.appendChild(mountEl);

  watermarkApp = createApp({
    render: () =>
      h(ElWatermark, { font: { color }, content: text, gap: [100, 100] }, () =>
        h("div", { style: "width:100vw;height:100vh" })
      )
  });
  watermarkApp.mount(mountEl);

  // 防删监听
  observer = new MutationObserver(() => {
    if (!document.getElementById(eleId)) createWatermark();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

export function removeWatermark() {
  observer?.disconnect();
  observer = null;

  document.getElementById(eleId)?.remove();

  watermarkApp?.unmount();
  watermarkApp = null;
}

export function setupWatermark(router: Router) {
  router.afterEach(to => {
    excludePage.includes(to.path) ? removeWatermark() : createWatermark();
  });
}
